var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModem02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20472 10.5578C5.72578 8.76958 6.08709 6.80312 7.28865 5.28372M17.7952 10.5578C18.2742 8.76954 17.9129 6.80308 16.7113 5.28367M2.34183 11.5996C1.50387 8.47487 2.20543 5.02324 4.44651 2.44586M21.6547 11.5997C22.4926 8.47491 21.7911 5.02328 19.55 2.4459M12 15V8.99998M5.49998 18.5H9.49998M5.19998 22H18.8C19.9201 22 20.4801 22 20.908 21.782C21.2843 21.5902 21.5902 21.2843 21.782 20.908C22 20.4801 22 19.9201 22 18.8V18.2C22 17.0799 22 16.5198 21.782 16.092C21.5902 15.7157 21.2843 15.4097 20.908 15.218C20.4801 15 19.9201 15 18.8 15H5.19998C4.07987 15 3.51982 15 3.092 15.218C2.71567 15.4097 2.40971 15.7157 2.21796 16.092C1.99998 16.5198 1.99998 17.0799 1.99998 18.2V18.8C1.99998 19.9201 1.99998 20.4801 2.21796 20.908C2.40971 21.2843 2.71567 21.5902 3.092 21.782C3.51982 22 4.07987 22 5.19998 22Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModem02);
export default __webpack_public_path__ + "static/media/modem-02.6bed52f6812d355cc96abfb3bbe43a0a.svg";
export { ForwardRef as ReactComponent };